import { availableTranslations, translations } from "../i18n/translations";
var DEFAULT_LANG = 'en';
export var translate = function (forceLang) {
    var userLanguage;
    if (forceLang) {
        userLanguage = forceLang;
    }
    else {
        var lang = navigator.language || null, userLanguage = lang ? lang.substring(0, 2) : DEFAULT_LANG;
        if (availableTranslations.indexOf(userLanguage) < 0) {
            userLanguage = DEFAULT_LANG;
        }
    }
    for (var key in translations[userLanguage]) {
        // Find the DOM element with the corresponding id and update its text
        var elementToTranslate = document.getElementById(key);
        if (elementToTranslate) {
            elementToTranslate.textContent = translations[userLanguage][key];
        }
        else {
            console.debug("CMS: Unexpected key [".concat(key, "] is missing in DOM."));
        }
    }
};
